export default __webpack_public_path__ + "static/media/dawiyat-sample.508f6b43.svg";